<template>
  <div class="container container-small container-expand bg-light2">
    <form action="#"
          method="post"
          @submit.prevent="sendProductForm(productMsg, productID)"
          class="product-form-wrapper">
      <section class="product-form-msg">
        <AccentHeader
          :header="productData.single.msg.header"
          :underline="true"
          :uppercase="false"
        />

        <div class="contact-form-respond bg-light2 text-center"
            v-if="inMsgProgress || isMsgSent">
          <div class="text-s" v-if="inMsgProgress && !isMsgSent">
            {{ contactData.form.progressMsg }}
          </div>
          <div class="text-l" v-if="isMsgSent">
            {{ msgSentLabel }}
          </div>
        </div>

        <textarea name="product-msg"
                  id="product-msg"
                  v-model="productMsg"
                  cols="30"
                  rows="10"
                  :placeholder="productData.single.msg.placeholder">
        </textarea>
      </section>
      <section class="product-form-uploads">
        <FilesUpload @uploadedFiles="appendUploadedFilesArray" v-if="!inMsgProgress" />
      </section>
      <section class="product-form-submit">
        <button type="submit"
                class="btn-simple"
                :disabled="productMsg.length < 3 && !productFiles.length">
          <span>{{ productData.single.msg.button }}</span>
        </button>
      </section>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FilesUpload from '@/components/product/FilesUpload.vue'
import AccentHeader from '@/components/AccentHeader.vue'
import axios from 'axios'

export default {
  name: 'ProductForm',
  components: {
    AccentHeader,
    FilesUpload
  },
  props: {
    productID: Number
  },
  data: function () {
    return {
      productMsg: '',
      productFiles: [],
      inMsgProgress: false,
      isMsgSent: false,
      msgSentLabel: ''
    }
  },
  computed: {
    ...mapGetters([
      'contactData',
      'productData',
      'apiPath',
      'currentUser'
    ])
  },
  methods: {
    appendUploadedFilesArray (arr) {
      this.productFiles = arr
    },
    sendProductForm (msg, productId) {
      let bearerParam = (this.authToken ? '?bearer=' + this.authToken : '')
      let formData = new FormData()

      if (msg) {
        formData.append('text', msg)
      }
      if (productId) {
        formData.append('id', productId)
      }
      if (this.currentUser) {
        formData.append('user', this.currentUser)
      }

      this.inMsgProgress = true

      if (this.productFiles.length) {
        this.productFiles.forEach((productFile) => {
          formData.append('files[]', productFile)
        })
      }

      // SENDING FORM;
      // axios.post(`${this.apiPath}productForm`, formData, {
      axios.post(`${this.apiPath}productForm${bearerParam}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
        // headers: {
        //   'Content-Type': 'multipart/form-data',
        //   'Authorization': `Bearer ${this.authToken}`
        // }
      }).then(() => {
        this.isMsgSent = true
        this.productMsg = ''
        this.productFiles = []
        this.msgSentLabel = this.contactData.form.successMsg

        setTimeout(() => {
          this.inMsgProgress = false
          this.isMsgSent = false
        }, 3000)
      }).catch((_err) => {
        console.log('Exhibit Form / ' + _err)
        if (_err.response && _err.response.status === 401) {
          this.$router.push({
            'name': 'login',
            'query': { 'logout': 'success' }
          })
        }
        this.isMsgSent = true
        this.msgSentLabel = this.contactData.form.errorMsg
        this.productMsg = msg || ''
        this.productFiles = []

        setTimeout(() => {
          this.inMsgProgress = false
          this.isMsgSent = false
        }, 3000)
      })
    }
  },
  mounted () {
    this.msgSentLabel = this.contactData.form.successMsg
  }
}
</script>

<style scoped lang="scss">
.product-form {

  h2 {
    margin-bottom: $gap-xl;
  }

  &-wrapper {
    position: relative;
  } // END .product-form-wrapper;

  &-msg {
    margin-bottom: $gap-xl;
  } // END .product-form-msg;

  &-uploads {
    margin-bottom: $gap-xl;
    position: relative;
  } // END .product-form-uploads;

  &-submit {
    text-align: right;
    width: 100%;
  } // END .product-form-submit;

  @include screen('md') {
    &-wrapper {
      display: flex;
      flex-flow: row wrap;
      margin: 0 auto;
      max-width: $container-content-max-width;
    } // END product-form-wrapper;

    &-msg {
      padding: 0 $gap-xl 0 0;
      width: calc(100% - #{$product-details-column-right});

      textarea {
        height: 290px;
        margin-left: ($gap-lg * -1);
        position: relative;
      }
    }
    &-uploads {
      width: $product-details-column-right;
    }
    &-submit {
      flex-basis: 100%;
      min-width: 100%;
    }
  } // END @include screen('md');

} // END .product-form;
</style>
